import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-download\"><path d=\"M13 8v3.5c0 .8-.7 1.5-1.5 1.5h-7c-.8 0-1.5-.7-1.5-1.5V8H2v3.5C2 12.9 3.1 14 4.5 14h7c1.4 0 2.5-1.1 2.5-2.5V8z\" /><path d=\"m10.5 8.3-.7-.7-1.3 1.3V2h-1v6.9L6.2 7.6l-.7.7L8 10.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol